import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';

import {
    ActionsColumn,
    ConnectionColumn,
    IccidColumn,
    IdColumn,
    NameColumn,
    NumberColumn,
    StatusColumn,
} from './components';
import {
    Box,
    Container,
    Flex,
    Group,
    MultiSelect,
    Portal,
    Select,
    Text,
} from '@mantine/core';
import {
    getAgentEvents,
    getAgents,
    getMessageGroups,
} from '../../../../http/apiClient';
import {
    useDebouncedCallback,
    useDisclosure,
    useLocalStorage,
} from '@mantine/hooks';
import { useMemo, useState } from 'react';

import CampaignColumn from './components/CampaignColumn';
import FiltersMultiSelect from '../../../common/filtersMultiSelect/FiltersMultiSelect';
import { MantineReactTable } from 'mantine-react-table';
import RegistrationColumn from './components/RegistrationColumn';
import ResourceEventsModal from '../../../modals/events/EventsModal';
import { usePaginatedQuery } from '../../../../http/queries/usePaginatedQuery';

const AgentsView = ({ ...props }) => {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50,
    });

    const filterDebounce = useDebouncedCallback((query) => {
        setGlobalFilter(query);
    }, 600);

    const [
        detailsModalOpen,
        { open: openDetailsModal, close: closeDetailsModal },
    ] = useDisclosure();

    const [modalTab, setModalTab] = useState('events');
    const [modalItem, setModalItem] = useState(null);

    const {
        isLoading,
        isError,
        error,
        data: paginatedData,
    } = usePaginatedQuery({
        queryFn: (queryParams) => getAgents(queryParams),
        queryKey: ['agents'],
        refetchInterval: 15_0000,
        globalFilter,
        pagination,
        sorting,
    });

    const { data: agents, pagination: dataPagination } = paginatedData || {};
    const columns = useMemo(
        () => [
            NameColumn(),
            IccidColumn(),
            NumberColumn(),
            ConnectionColumn(),
            StatusColumn(),
            RegistrationColumn(),
            CampaignColumn(),
        ],
        [agents]
    );

    /*const tableData = useMemo(
        () => (isLoading ? [] : campaigns),
        [campaigns, isLoading]
    );*/

    const tableData = useMemo(
        () => (isLoading ? [] : agents),
        [agents, isLoading]
    );

    const [columnVisibility, setColumnVisibility] = useLocalStorage({
        key: 'agents-table-visibility', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const [columnSizing, setColumnSizing] = useLocalStorage({
        key: 'agents-group-table-sizing', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const handleVisibilityChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnVisibility((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handlSizeChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnSizing((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handleFilterChange = (queryStr) => {
        filterDebounce(queryStr);
    };

    const tableProps = {
        columns: columns,
        data: tableData,
        enableRowActions: true,
        enableColumnResizing: true,
        enableColumnActions: false,
        enableSorting: false,
        enableTopToolbar: true,
        enableGlobalFilter: true,
        enableFilters: false,
        enableStickyHeader: true,
        enableDensityToggle: false,
        positionActionsColumn: 'last',
        layoutMode: 'semantic',
        mantineSearchTextInputProps: {
            placeholder: 'Search Agents',
            miw: 200,
        },
        mantineTableContainerProps: {
            style: {
                minHeight: '80vh',
            },
        },

        positionGlobalFilter: 'left',
        renderTopToolbarCustomActions: () => (
            <Box
                w={'100%'}
                px={'lg'}>
                <FiltersMultiSelect
                    options={[{ label: 'test', value: 'test' }]}
                />
            </Box>
        ),

        renderRowActions: (props) => (
            <ActionsColumn
                {...props}
                setTab={setModalTab}
                setModalItem={setModalItem}
                openDetailsModal={openDetailsModal}
            />
        ),

        manualPagination: true,
        manualSorting: true,
        onColumnVisibilityChange: handleVisibilityChange,
        onColumnSizingChange: handlSizeChange,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        onGlobalFilterChange: handleFilterChange,
        rowCount: dataPagination?.totalItems || 0,
        pageCount: dataPagination?.totalPages || 1,

        initialState: {
            columnVisibility,
            pagination,
            isLoading,
            showGlobalFilter: true,
        },
        state: {
            isLoading,
            pagination,
            columnVisibility,
            columnSizing,
            showAlertBanner: isError,
            showProgressBars: isLoading,
            sorting,
            density: 'xs',
        },
    };

    return (
        <Container fluid>
            <MantineReactTable {...tableProps} />
            <ResourceEventsModal
                title={'Agent Events'}
                httpQueryFn={(queryParams) =>
                    getAgentEvents({
                        id: modalItem?.id,
                        pagination: queryParams,
                    })
                }
                queryKey={['agent_events', modalItem?.id]}
                openTab={modalTab}
                opened={detailsModalOpen}
                close={closeDetailsModal}
            />
        </Container>
    );
};
export default AgentsView;
